import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { useBrandContext } from '../App';

const MultiBrandCenter = () => {
  const { brands, addBrand, removeBrand } = useBrandContext();
  const [selectedBrand, setSelectedBrand] = useState('7-Eleven');
  const [showAddBrand, setShowAddBrand] = useState(false);
  const [newBrandName, setNewBrandName] = useState('');

  // Enhanced brand data with checklists 
  const [brandData, setBrandData] = useState({
    '7-Eleven': {
      color: 'bg-apache',
      stats: { x: 6, ig: 11, fb: 11, tt: 8 },
      dailyChecklist: [
        { id: 'd1', task: 'AM Platform Sweep', completed: false },
        { id: 'd2', task: 'Review Comments & DMs', completed: false },
        { id: 'd3', task: 'Monitor Mentions', completed: false },
        { id: 'd4', task: 'PM Engagement Check', completed: false },
        { id: 'd5', task: 'Daily KPI Review', completed: false }
      ],
      weeklyChecklist: [
        { id: 'w1', task: 'Content Calendar Review', completed: false },
        { id: 'w2', task: 'Creative Asset Approval', completed: false },
        { id: 'w3', task: 'Performance Report', completed: false },
        { id: 'w4', task: 'Strategy Planning', completed: false },
        { id: 'w5', task: 'Competitor Analysis', completed: false }
      ]
    },
    'Aperol': {
      color: 'bg-gold',
      stats: { x: 0, ig: 11, fb: 11, tt: 8 },
      dailyChecklist: [
        { id: 'd1', task: 'AM Platform Sweep', completed: false },
        { id: 'd2', task: 'Review Comments & DMs', completed: false },
        { id: 'd3', task: 'Monitor Mentions', completed: false },
        { id: 'd4', task: 'PM Engagement Check', completed: false },
        { id: 'd5', task: 'Daily KPI Review', completed: false }
      ],
      weeklyChecklist: [
        { id: 'w1', task: 'Content Calendar Review', completed: false },
        { id: 'w2', task: 'Creative Asset Approval', completed: false },
        { id: 'w3', task: 'Performance Report', completed: false },
        { id: 'w4', task: 'Strategy Planning', completed: false },
        { id: 'w5', task: 'Competitor Analysis', completed: false }
      ]
    },
    'CELSIUS': {
      color: 'bg-brown',
      stats: { x: 6, ig: 11, fb: 0, tt: 8 },
      dailyChecklist: [
        { id: 'd1', task: 'AM Platform Sweep', completed: false },
        { id: 'd2', task: 'Review Comments & DMs', completed: false },
        { id: 'd3', task: 'Monitor Mentions', completed: false },
        { id: 'd4', task: 'PM Engagement Check', completed: false },
        { id: 'd5', task: 'Daily KPI Review', completed: false }
      ],
      weeklyChecklist: [
        { id: 'w1', task: 'Content Calendar Review', completed: false },
        { id: 'w2', task: 'Creative Asset Approval', completed: false },
        { id: 'w3', task: 'Performance Report', completed: false },
        { id: 'w4', task: 'Strategy Planning', completed: false },
        { id: 'w5', task: 'Competitor Analysis', completed: false }
      ]
    },
    'OLIPOP': {
      color: 'bg-brown',
      stats: { x: 6, ig: 11, fb: 0, tt: 8 },
      dailyChecklist: [
        { id: 'd1', task: 'AM Platform Sweep', completed: false },
        { id: 'd2', task: 'Review Comments & DMs', completed: false },
        { id: 'd3', task: 'Monitor Mentions', completed: false },
        { id: 'd4', task: 'PM Engagement Check', completed: false },
        { id: 'd5', task: 'Daily KPI Review', completed: false }
      ],
      weeklyChecklist: [
        { id: 'w1', task: 'Content Calendar Review', completed: false },
        { id: 'w2', task: 'Creative Asset Approval', completed: false },
        { id: 'w3', task: 'Performance Report', completed: false },
        { id: 'w4', task: 'Strategy Planning', completed: false },
        { id: 'w5', task: 'Competitor Analysis', completed: false }
      ]
    },
    'PBR': {
      color: 'bg-apache',
      stats: { x: 6, ig: 11, fb: 11, tt: 0 },
      dailyChecklist: [
        { id: 'd1', task: 'AM Platform Sweep', completed: false },
        { id: 'd2', task: 'Review Comments & DMs', completed: false },
        { id: 'd3', task: 'Monitor Mentions', completed: false },
        { id: 'd4', task: 'PM Engagement Check', completed: false },
        { id: 'd5', task: 'Daily KPI Review', completed: false }
      ],
      weeklyChecklist: [
        { id: 'w1', task: 'Content Calendar Review', completed: false },
        { id: 'w2', task: 'Creative Asset Approval', completed: false },
        { id: 'w3', task: 'Performance Report', completed: false },
        { id: 'w4', task: 'Strategy Planning', completed: false },
        { id: 'w5', task: 'Competitor Analysis', completed: false }
      ]
    },
    'Arrowhead Water': {
      color: 'bg-gold',
      stats: { x: 0, ig: 11, fb: 11, tt: 0 },
      dailyChecklist: [
        { id: 'd1', task: 'AM Platform Sweep', completed: false },
        { id: 'd2', task: 'Review Comments & DMs', completed: false },
        { id: 'd3', task: 'Monitor Mentions', completed: false },
        { id: 'd4', task: 'PM Engagement Check', completed: false },
        { id: 'd5', task: 'Daily KPI Review', completed: false }
      ],
      weeklyChecklist: [
        { id: 'w1', task: 'Content Calendar Review', completed: false },
        { id: 'w2', task: 'Creative Asset Approval', completed: false },
        { id: 'w3', task: 'Performance Report', completed: false },
        { id: 'w4', task: 'Strategy Planning', completed: false },
        { id: 'w5', task: 'Competitor Analysis', completed: false }
      ]
    },
    'CHOMPS': {
      color: 'bg-brown',
      stats: { x: 6, ig: 11, fb: 0, tt: 8 },
      dailyChecklist: [
        { id: 'd1', task: 'AM Platform Sweep', completed: false },
        { id: 'd2', task: 'Review Comments & DMs', completed: false },
        { id: 'd3', task: 'Monitor Mentions', completed: false },
        { id: 'd4', task: 'PM Engagement Check', completed: false },
        { id: 'd5', task: 'Daily KPI Review', completed: false }
      ],
      weeklyChecklist: [
        { id: 'w1', task: 'Content Calendar Review', completed: false },
        { id: 'w2', task: 'Creative Asset Approval', completed: false },
        { id: 'w3', task: 'Performance Report', completed: false },
        { id: 'w4', task: 'Strategy Planning', completed: false },
        { id: 'w5', task: 'Competitor Analysis', completed: false }
      ]
    }
  });

  const currentData = brandData[selectedBrand] || { color: 'bg-brown', stats: { x: 6, ig: 11, fb: 11, tt: 8 }, dailyChecklist: [], weeklyChecklist: [] };

  const handleAddBrand = () => {
    if (newBrandName.trim() && !brands.includes(newBrandName.trim())) {
      addBrand(newBrandName);
      // Initialize brand data for new brand
      setBrandData(prev => ({
        ...prev,
        [newBrandName.trim()]: {
          color: 'bg-brown',
          stats: { x: 6, ig: 11, fb: 11, tt: 8 },
          dailyChecklist: [
            { id: 'd1', task: 'AM Platform Sweep', completed: false },
            { id: 'd2', task: 'Review Comments & DMs', completed: false },
            { id: 'd3', task: 'Monitor Mentions', completed: false },
            { id: 'd4', task: 'PM Engagement Check', completed: false },
            { id: 'd5', task: 'Daily KPI Review', completed: false }
          ],
          weeklyChecklist: [
            { id: 'w1', task: 'Content Calendar Review', completed: false },
            { id: 'w2', task: 'Creative Asset Approval', completed: false },
            { id: 'w3', task: 'Performance Report', completed: false },
            { id: 'w4', task: 'Strategy Planning', completed: false },
            { id: 'w5', task: 'Competitor Analysis', completed: false }
          ]
        }
      }));
      setNewBrandName('');
      setShowAddBrand(false);
      setSelectedBrand(newBrandName.trim());
    }
  };

  const handleRemoveBrand = (brandToRemove) => {
    removeBrand(brandToRemove);
    setBrandData(prev => {
      const newData = { ...prev };
      delete newData[brandToRemove];
      return newData;
    });
    if (selectedBrand === brandToRemove) {
      setSelectedBrand(brands.find(b => b !== brandToRemove) || brands[0]);
    }
  };

  const toggleDailyTask = (taskId) => {
    setBrandData(prev => ({
      ...prev,
      [selectedBrand]: {
        ...prev[selectedBrand],
        dailyChecklist: prev[selectedBrand].dailyChecklist.map(task =>
          task.id === taskId ? { ...task, completed: !task.completed } : task
        )
      }
    }));
  };

  const toggleWeeklyTask = (taskId) => {
    setBrandData(prev => ({
      ...prev,
      [selectedBrand]: {
        ...prev[selectedBrand],
        weeklyChecklist: prev[selectedBrand].weeklyChecklist.map(task =>
          task.id === taskId ? { ...task, completed: !task.completed } : task
        )
      }
    }));
  };

  const resetDailyChecklist = () => {
    setBrandData(prev => ({
      ...prev,
      [selectedBrand]: {
        ...prev[selectedBrand],
        dailyChecklist: prev[selectedBrand].dailyChecklist.map(task => ({ ...task, completed: false }))
      }
    }));
  };

  const resetWeeklyChecklist = () => {
    setBrandData(prev => ({
      ...prev,
      [selectedBrand]: {
        ...prev[selectedBrand],
        weeklyChecklist: prev[selectedBrand].weeklyChecklist.map(task => ({ ...task, completed: false }))
      }
    }));
  };

  const calculateProgress = (checklist) => {
    if (!checklist || checklist.length === 0) return 0;
    const completed = checklist.filter(task => task.completed).length;
    return Math.round((completed / checklist.length) * 100);
  };

  const dailyProgress = calculateProgress(currentData.dailyChecklist);
  const weeklyProgress = calculateProgress(currentData.weeklyChecklist);

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="max-w-7xl mx-auto">
      <h1 className="section-title">Multi-Brand Command Center</h1>

      {/* Brand Selector Grid */}
      <div className="mb-8">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-bold text-brown">Brand Portfolio</h2>
          <motion.button
            onClick={() => setShowAddBrand(!showAddBrand)}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="apple-button flex items-center"
          >
            <SafeIcon name="Plus" className="w-4 h-4 mr-2" />
            Add Brand
          </motion.button>
        </div>

        {/* Add Brand Form */}
        <AnimatePresence>
          {showAddBrand && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              className="mb-4 p-4 glass-card rounded-2xl border border-white/30"
            >
              <div className="flex gap-3">
                <input
                  type="text"
                  value={newBrandName}
                  onChange={(e) => setNewBrandName(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleAddBrand()}
                  placeholder="Enter brand name..."
                  className="apple-input text-brown flex-1"
                />
                <motion.button
                  onClick={handleAddBrand}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="px-4 py-2 bg-apache text-white rounded-xl font-medium hover:bg-apache/80 transition-colors"
                >
                  Add
                </motion.button>
                <motion.button
                  onClick={() => { setShowAddBrand(false); setNewBrandName(''); }}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="px-4 py-2 bg-brown/20 text-brown rounded-xl font-medium hover:bg-brown/30 transition-colors"
                >
                  Cancel
                </motion.button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Brand Pills with Progress Indicators */}
        <div className="grid grid-cols-4 md:grid-cols-8 gap-3">
          {brands.map(brand => {
            const brandDailyProgress = calculateProgress(brandData[brand]?.dailyChecklist || []);
            const brandWeeklyProgress = calculateProgress(brandData[brand]?.weeklyChecklist || []);
            const overallProgress = Math.round((brandDailyProgress + brandWeeklyProgress) / 2);
            return (
              <div key={brand} className="relative group">
                <motion.button
                  onClick={() => setSelectedBrand(brand)}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className={`w-full p-2 rounded-xl text-xs font-bold transition-all relative ${
                    selectedBrand === brand
                      ? 'gradient-brown text-gold shadow-lg scale-105'
                      : 'glass-card text-brown/70 hover:text-brown border border-white/30'
                  }`}
                >
                  <div className="relative">
                    {brand}
                    {/* Progress indicator */}
                    <div className="absolute -top-1 -right-1">
                      <div className={`w-3 h-3 rounded-full ${
                        overallProgress === 100 ? 'bg-apache' :
                        overallProgress >= 50 ? 'bg-gold' : 'bg-beige'
                      }`}></div>
                    </div>
                  </div>
                </motion.button>
                {brands.length > 1 && (
                  <motion.button
                    onClick={() => handleRemoveBrand(brand)}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center"
                    title="Remove brand"
                  >
                    <SafeIcon name="X" className="w-3 h-3" />
                  </motion.button>
                )}
              </div>
            );
          })}
        </div>
      </div>

      <AnimatePresence mode="wait">
        <motion.div
          key={selectedBrand}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -20, opacity: 0 }}
          className="grid grid-cols-1 lg:grid-cols-3 gap-6"
        >
          {/* Brand Status Card */}
          <div className="lg:col-span-2 section-card border-t-4" style={{ borderColor: '#6A4F3A' }}>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-brown">{selectedBrand}</h2>
              <div className="flex space-x-3">
                <div className="px-3 py-1 bg-apache/10 text-apache rounded-full text-sm font-medium flex items-center">
                  <div className="w-2 h-2 bg-apache rounded-full mr-2"></div>
                  AM Check
                </div>
                <div className="px-3 py-1 bg-beige text-brown/50 rounded-full text-sm font-medium flex items-center">
                  <div className="w-2 h-2 bg-brown/40 rounded-full mr-2"></div>
                  PM Check
                </div>
              </div>
            </div>

            <h3 className="text-sm font-bold text-brown/50 uppercase mb-4">Monthly Quota Progress</h3>
            <div className="space-y-4 mb-8">
              {Object.entries(currentData.stats).map(([platform, count]) => (
                count > 0 && (
                  <div key={platform}>
                    <div className="flex justify-between text-sm mb-1">
                      <span className="font-medium uppercase text-brown">{platform}</span>
                      <span className="text-brown/60">0 / {count}</span>
                    </div>
                    <div className="h-2 bg-beige rounded-full overflow-hidden">
                      <motion.div
                        initial={{ width: 0 }}
                        animate={{ width: '30%' }} // Simulated progress
                        className={`h-full ${currentData.color}`}
                      />
                    </div>
                  </div>
                )
              ))}
            </div>

            {/* Enhanced Checklists */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Daily Checklist */}
              <div className="glass-card rounded-2xl p-5 border border-white/30">
                <div className="flex justify-between items-center mb-4">
                  <h3 className="font-bold text-brown flex items-center">
                    <SafeIcon name="Clock" className="w-4 h-4 mr-2 text-gold" />
                    Daily Tasks
                  </h3>
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-bold text-gold">{dailyProgress}%</span>
                    <motion.button
                      onClick={resetDailyChecklist}
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                      className="w-6 h-6 bg-beige/50 rounded-full flex items-center justify-center"
                      title="Reset daily tasks"
                    >
                      <SafeIcon name="RefreshCw" className="w-3 h-3 text-brown/60" />
                    </motion.button>
                  </div>
                </div>
                <div className="mb-3">
                  <div className="h-2 bg-beige/30 rounded-full overflow-hidden">
                    <motion.div
                      initial={{ width: 0 }}
                      animate={{ width: `${dailyProgress}%` }}
                      className="h-full gradient-gold rounded-full"
                    />
                  </div>
                </div>
                <div className="space-y-2">
                  {currentData.dailyChecklist.map((task, index) => (
                    <motion.div
                      key={task.id}
                      initial={{ opacity: 0, x: -10 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: index * 0.05 }}
                      whileHover={{ x: 4 }}
                      onClick={() => toggleDailyTask(task.id)}
                      className="flex items-center gap-3 p-2 rounded-lg hover:bg-gold/10 transition-colors cursor-pointer"
                    >
                      <motion.button
                        whileHover={{ scale: 1.2 }}
                        whileTap={{ scale: 0.8 }}
                        className={`w-5 h-5 rounded-full transition-all ${
                          task.completed ? 'bg-apache text-white' : 'bg-beige border-2 border-gold/30'
                        }`}
                      >
                        {task.completed && <SafeIcon name="Check" className="w-3 h-3" />}
                      </motion.button>
                      <span className={`text-sm transition-all ${
                        task.completed ? 'text-brown/40 line-through' : 'text-brown'
                      }`}>
                        {task.task}
                      </span>
                    </motion.div>
                  ))}
                </div>
              </div>

              {/* Weekly Checklist */}
              <div className="glass-card rounded-2xl p-5 border border-white/30">
                <div className="flex justify-between items-center mb-4">
                  <h3 className="font-bold text-brown flex items-center">
                    <SafeIcon name="Calendar" className="w-4 h-4 mr-2 text-gold" />
                    Weekly Tasks
                  </h3>
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-bold text-gold">{weeklyProgress}%</span>
                    <motion.button
                      onClick={resetWeeklyChecklist}
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                      className="w-6 h-6 bg-beige/50 rounded-full flex items-center justify-center"
                      title="Reset weekly tasks"
                    >
                      <SafeIcon name="RefreshCw" className="w-3 h-3 text-brown/60" />
                    </motion.button>
                  </div>
                </div>
                <div className="mb-3">
                  <div className="h-2 bg-beige/30 rounded-full overflow-hidden">
                    <motion.div
                      initial={{ width: 0 }}
                      animate={{ width: `${weeklyProgress}%` }}
                      className="h-full gradient-apache rounded-full"
                    />
                  </div>
                </div>
                <div className="space-y-2">
                  {currentData.weeklyChecklist.map((task, index) => (
                    <motion.div
                      key={task.id}
                      initial={{ opacity: 0, x: -10 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: index * 0.05 }}
                      whileHover={{ x: 4 }}
                      onClick={() => toggleWeeklyTask(task.id)}
                      className="flex items-center gap-3 p-2 rounded-lg hover:bg-gold/10 transition-colors cursor-pointer"
                    >
                      <motion.button
                        whileHover={{ scale: 1.2 }}
                        whileTap={{ scale: 0.8 }}
                        className={`w-5 h-5 rounded-full transition-all ${
                          task.completed ? 'bg-apache text-white' : 'bg-beige border-2 border-gold/30'
                        }`}
                      >
                        {task.completed && <SafeIcon name="Check" className="w-3 h-3" />}
                      </motion.button>
                      <span className={`text-sm transition-all ${
                        task.completed ? 'text-brown/40 line-through' : 'text-brown'
                      }`}>
                        {task.task}
                      </span>
                    </motion.div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="space-y-4">
            {/* Overall Brand Progress */}
            <div className="glass-card rounded-2xl p-5 border border-white/30">
              <h3 className="font-bold text-brown mb-4">Overall Progress</h3>
              <div className="space-y-3">
                <div>
                  <div className="flex justify-between text-sm mb-1">
                    <span className="text-brown/60">Daily Completion</span>
                    <span className="font-bold text-gold">{dailyProgress}%</span>
                  </div>
                  <div className="h-3 bg-beige/30 rounded-full overflow-hidden">
                    <motion.div
                      initial={{ width: 0 }}
                      animate={{ width: `${dailyProgress}%` }}
                      className="h-full gradient-gold rounded-full"
                    />
                  </div>
                </div>
                <div>
                  <div className="flex justify-between text-sm mb-1">
                    <span className="text-brown/60">Weekly Completion</span>
                    <span className="font-bold text-apache">{weeklyProgress}%</span>
                  </div>
                  <div className="h-3 bg-beige/30 rounded-full overflow-hidden">
                    <motion.div
                      initial={{ width: 0 }}
                      animate={{ width: `${weeklyProgress}%` }}
                      className="h-full gradient-apache rounded-full"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="glass-card rounded-2xl p-5 border border-white/30">
              <h3 className="font-bold text-brown mb-3">Brand Voice</h3>
              <div className="text-sm text-brown/80 italic">
                "Friendly, community-focused, and always helpful."
              </div>
            </div>

            <div className="glass-card rounded-2xl p-5 border border-white/30">
              <h3 className="font-bold text-brown mb-3">Quick Links</h3>
              <div className="space-y-2">
                <motion.button
                  whileHover={{ x: 4 }}
                  className="w-full text-left text-sm text-gold hover:text-gold/80 transition-colors flex items-center"
                >
                  <SafeIcon name="Folder" className="w-4 h-4 mr-2" />
                  Open Assets Folder
                </motion.button>
                <motion.button
                  whileHover={{ x: 4 }}
                  className="w-full text-left text-sm text-gold hover:text-gold/80 transition-colors flex items-center"
                >
                  <SafeIcon name="FileText" className="w-4 h-4 mr-2" />
                  View Guidelines
                </motion.button>
                <motion.button
                  whileHover={{ x: 4 }}
                  className="w-full text-left text-sm text-gold hover:text-gold/80 transition-colors flex items-center"
                >
                  <SafeIcon name="Phone" className="w-4 h-4 mr-2" />
                  Emergency Contact
                </motion.button>
              </div>
            </div>
          </div>
        </motion.div>
      </AnimatePresence>
    </motion.div>
  );
};

export default MultiBrandCenter;